import React from "react";
import { Link } from "react-navi";
import ArticleMeta from "./ArticleMeta";
import styles from "./ArticleSummary.module.css";

function ArticleSummary({ blogRoot, route, variant }) {
  const summaryClassName =
    variant === "featured"
      ? `${styles.ArticleSummary} ${styles.featured}`
      : styles.ArticleSummary;

  return (
    <article className={summaryClassName}>
      <span className={styles.kicker}>Article</span>
      <h2>
        <Link href={route.url.href}>{route.title}</Link>
      </h2>
      <ArticleMeta blogRoot={blogRoot} meta={route.data} />
      <p>{route.data.spoiler}</p>
      <Link href={route.url.href} className={styles.readMore}>
        Read article
      </Link>
    </article>
  );
}

export default ArticleSummary;
